var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01132 11.4873L6.32201 11.4696L13.5597 4.25696C13.7006 4.11519 13.8092 3.95274 13.8855 3.76962C13.9618 3.5865 14 3.39452 14 3.19367C14 2.99283 13.9618 2.80084 13.8855 2.61772C13.8092 2.4346 13.7006 2.27215 13.5597 2.13038L12.3623 0.925317C12.0805 0.641772 11.7283 0.5 11.3057 0.5C10.883 0.5 10.5308 0.641772 10.2491 0.925317L3.01132 8.13797V11.4873ZM11.3057 1.98861L12.5031 3.19367L11.3057 4.38101L10.1082 3.19367L11.3057 1.98861ZM4.50818 8.77595L9.03396 4.25696L10.2314 5.4443L5.70566 9.96329H4.50818V8.77595ZM1.49686 14.5H12.0277C12.4386 14.5 12.7908 14.3523 13.0843 14.057C13.3778 13.7616 13.5245 13.4072 13.5245 12.9937V6.43671L12.0277 7.94304V12.9937H3.87421C3.86247 12.9937 3.85367 12.9937 3.8478 12.9937C3.84193 12.9937 3.83312 12.9937 3.82138 12.9937C3.80964 12.9937 3.7979 12.9937 3.78616 12.9937C3.77442 12.9937 3.75681 12.9937 3.73333 12.9937H1.49686V2.41392H6.63899L8.15346 0.889874H1.49686C1.08595 0.889874 0.733753 1.03755 0.440252 1.33291C0.146751 1.62827 0 1.98861 0 2.41392V12.9937C0 13.4072 0.146751 13.7616 0.440252 14.057C0.733753 14.3523 1.08595 14.5 1.49686 14.5Z",
    fill: "#1E1A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditM);
export default __webpack_public_path__ + "static/media/editM.64d3be81cbf409a6d12dd7b35d836d69.svg";
export { ForwardRef as ReactComponent };